import { Component, OnInit, ViewChild, Input } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { ReceiverSelectionStoreService } from '../../services/receiver-selection-store/receiver-selection-store.service';
import { DxSelectBoxComponent } from 'devextreme-angular';
import { AttributesEntity } from '../../models/configuration.model';

@Component({
  selector: 'baf-receiver-selector',
  templateUrl: './receiver-selector.component.html',
  styleUrls: ['./receiver-selector.component.css'],
  providers: [ReceiverSelectionStoreService]
})
export class ReceiverSelectorComponent implements OnInit {
  private wasReceiverCleared = false;
  readonly receiverComboText = 'Wybierz adresata z listy...';
  readonly noDataLoadedText = 'Brak załadowanych danych';

  get receivers(): DataSource {
    return this.receiverSelectionStore.receivers;
  }

  @Input()
  attribute: AttributesEntity;

  @ViewChild(DxSelectBoxComponent)
  private receiverSelector: DxSelectBoxComponent;

  constructor(private receiverSelectionStore: ReceiverSelectionStoreService) {}

  ngOnInit() {}

  onReceiverValueChanged(event) {
    if (event.value === this.receiverSelectionStore.fetchAllMarkerId) {
      this.clearReceiver();
      this.receiverSelectionStore
        .loadAllReceivers()
        .then(() => this.receiverSelector.instance.open());
    } else if (!event.value) {
      if (this.wasReceiverCleared) {
        this.wasReceiverCleared = false;
      } else {
        this.receiverSelectionStore.removeRecentlySelectedReceiver(event.previousValue).then(() => {
          this.receiverSelectionStore
            .loadRecentReceivers()
            .then(() => this.receiverSelector.instance.open());
        });
      }
    } else {
      this.receiverSelectionStore.addRecentlySelectedReceiver(event.value, 0);
    }
  }

  reload() {
    this.receiverSelectionStore.loadRecentReceivers(this.attribute);
  }

  updateStatistics() {
    this.receiverSelectionStore.addRecentlySelectedReceiver(this.receiverSelector.value);
  }

  clearSelection() {
    this.receiverSelectionStore.clearValues();
    this.clearReceiver();
  }

  private clearReceiver() {
    this.wasReceiverCleared = true;
    this.receiverSelector.value = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/receiver-selector/receiver-selector.component.ts